<template>
  <section>
    <nav class="level">
      <div class="level-left">
        
      </div>
      <div class="level-center">
        <div class="level-item">
            
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <b-button type="is-success" tag="router-link" to="inventory/adjustment" v-can="'adjust_inventory'" icon-pack="fas" icon-left="dolly-flatbed">ปรับยอดสินค้า</b-button>
            <b-button type="is-info" icon-pack="fas" icon-left="print" @click="printpdf()">พิมพ์ยอดสินค้า</b-button>
          </div>
        </div>
      </div>
    </nav>
    <div class="level-right">
      <b-input placeholder="Search..." v-model="search_query" type="search" icon="search" icon-pack="fas" width="250"></b-input>
    </div>
    <h1 class="section-head">สินค้าคงคลัง</h1>

    <div>
      <b-table
        :data="filteredData"
        selectable @click="selected"
        :selected.sync="selectedItem"
        :hoverable="true"
        :loading="isTableLoading"

        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :narrowed="true"
      >
        <template slot-scope="props">
          <b-table-column field="id" label="ID" width="40" numeric>
              {{ props.row.id }}
          </b-table-column>

          <b-table-column field="name"  label="ชื่อผลิตภัณฑ์">
              {{ props.row.name }}
          </b-table-column>

          <b-table-column field="sup_name" label="ซัพพลายเออร์">
              {{ props.row.sup_name }}
          </b-table-column>

          <b-table-column field="price_sell" label="ราคาซื้อ" width="180">
              {{ parseFloat(props.row.price_buy).formatMoney(2) }}  บาท/{{ props.row.unit_buy_text }}
          </b-table-column>

          <b-table-column field="price_sell" label="ราคาขาย (PG - ทั่วไป)" width="220">
              {{ parseFloat(props.row.price_sell).formatMoney(2) }} - {{ parseFloat(props.row.general_price_sell).formatMoney(2) }} บาท/{{ props.row.unit_sell_text }}
          </b-table-column>

          <b-table-column field="price_buy" label="ขั้นต่ำ" width="100">
              {{ props.row.reorder ? props.row.reorder:0 }} {{ props.row.unit_sell_text }}
          </b-table-column>

          <b-table-column field="price_buy" label="คงเหลือ"  width="100">
              <span :class="(parseFloat(props.row.in_stock) < parseFloat(props.row.reorder) ? 'alert-reorder':'')">{{props.row.in_stock}}</span> {{ props.row.unit_sell_text }}
          </b-table-column>
        </template>
      </b-table>
      <div class="notification has-text-centered" v-if="all_product.length == 0 && !isTableLoading">ไม่พบข้อมูล</div>
    </div>
  </section>
</template>

<script>
  import ProductModel from '@/model/product_model'
  import Request from '@/libraries/request'
  import Const from '@/const/const'
  import Config from '@/libraries/config'

  export default {
    name: 'Product',
    props: ['supId'],
    data() {
      return {
        all_product: [],
        selectedItem: {},
        lastSelected: {},
        isTableLoading: true,
        isPaginated: true,
        isPaginationSimple: false,
        currentPage: 1,
        perPage: 30,
        search_query: "",
      }
    },
    mounted() {
      this.init();
    },
    computed: {
      filteredData: function() {
        return this.all_product.filter(product => {
          return (
                  (product.code && product.code.toLowerCase().includes(this.search_query.toLowerCase()))
                  || (product.sup_name && product.sup_name.toLowerCase().includes(this.search_query.toLowerCase()))
                  || (product.name && product.name.toLowerCase().includes(this.search_query.toLowerCase()))

                )
        })
      }
    },
    methods: {
      async init(){
        this.all_product = await ProductModel.get_all_product(this.supId);
        this.isTableLoading = false;
      },
      printpdf(){
        window.open(Config.baseUrl +"/v"+Config.version+ "/printpdf/inventory", '_blank');
      },
      selected(item) {
        if(this.lastSelected == item){
          this.$router.push({ path: '/product/edit/'+item.id })
        }
        this.lastSelected = item;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .alert-reorder {
    font-weight: bolder;
    color: #FFF;
    background-color: red;
    padding: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Inventory/index.vue